// src/components/common/Button.jsx
export default function Button({
  buttonnumber,
  text,
  theme,
  handleClick,
  ui = {},               
}) {
  const {
    px = 24,             
    py = 20,             
    minH = 150,          
    radius = 12,         
    labelSize = 48,      
    descSize = 24,       
    gap = 12,            
  } = ui;

  return (
    <button
      title={buttonnumber}
      className="w-full flex flex-col justify-start items-center uppercase shadow-2xl"
      style={{
        backgroundColor: theme.buttonColor,
        color: theme.textColor,
        padding: `${py}px ${px}px`,
        minHeight: `${minH}px`,
        borderRadius: `${radius}px`,
      }}
      onClick={handleClick}
    >
      <h1
        className="font-bold"
        style={{ fontSize: `${labelSize}px`, lineHeight: 1 }}
      >
        TASTE {buttonnumber}
      </h1>
      <p
        className="text-center"
        style={{ fontSize: `${descSize}px`, marginTop: `${gap}px`, lineHeight: 1.1 }}
      >
        {text}
      </p>
    </button>
  );
}